import * as LABELS_ACTIONS from '../../../common/labels/labelConstants';
import { produce } from 'immer';
import {
    LabelAction,
    LabelCreateAction,
    LabelDeleteAction,
    LabelMap,
    LabelsLoadAction,
    LabelUpdateAction,
} from '../../../common/labels/labelTypes';
import * as LABELS_ACTION_TYPE from '../../../common/labels/labelConstants';

const initialState: LabelMap = {};

const labelsReducer = (state = initialState, action: LabelAction): LabelMap => {
    switch (action.type) {
        case LABELS_ACTIONS.LABELS_LOAD:
            return produce(state, (draft) => {
                (action as LabelsLoadAction).labels.forEach((label) => {
                    draft[label.id as string] = label;
                });
            });

        case LABELS_ACTION_TYPE.LABEL_CREATE:
            return produce(state, (draft) => {
                const { label } = action as LabelCreateAction;

                draft[label.id as string] = label;
            });

        case LABELS_ACTIONS.LABEL_UPDATE:
            return produce(state, (draft) => {
                const { labelId, changes } = action as LabelUpdateAction;
                const existingLabel = draft[labelId];
                if (!existingLabel) return;

                draft[labelId] = { ...existingLabel, ...changes };
            });

        case LABELS_ACTIONS.LABEL_DELETE:
            return produce(state, (draft) => {
                const labelId = (action as LabelDeleteAction).labelId;
                delete draft[labelId];
            });

        default:
            return state;
    }
};

export default labelsReducer;
